//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import AppDl from '~/components/landing/app_dl'
import { directive } from 'vue-awesome-swiper'
import Swiper from 'swiper'
import Modal from '~/components/partials/webapp_modal'
import 'swiper/swiper.scss'
export default {
  name: 'ArzyptoApplication',
  directives: {
    swiper: directive
  },
  components: {
    Modal
  },
  data () {
    return {
      num: 1,
      titles: [this.$t('common.exchangeMarket'), this.$t('common.instantTransaction'), this.$t('common.assetManagment'), this.$t('common.priceAlert')],
      showWebapp: false
      // swiperOption: {
      //   direction: 'vertical',
      //   slidesPerView: 1,
      //   spaceBetween: 15,
      //   slidesPerGroup: 1,
      //   autoplay: {
      //     delay: 5000
      //   },
      //   draggable: true,
      //   loop: true,
      //   pagination: {
      //     el: '.swiper-pagination',
      //     clickable: true,
      //     renderBullet (index, className) {
      //       return '<span class="' + className + '">slide1</span>'
      //     }
      //   },
      //   breakpoints: {
      //     991: {
      //       slidesPerView: 1
      //     },
      //     767: {
      //       slidesPerView: 1
      //     },
      //     0: {
      //       slidesPerView: 1
      //     }
      //   }
      // }
    }
  },
  mounted () {
    const vm = this
    setTimeout(function () {
      return new Swiper('#swiper-container', {
        a11y: false,
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 150,
        draggable: true,
        autoplay: {
          delay: 5000
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet (index, className) {
            return '<span class="' + className + '">' + vm.titles[index] + '</span>'
          }
        // bulletClass: 'swiper-pagination-items',
        // bulletActiveClass: 'swiper-pagination-items-active'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      })
    }, 1000)
  },
  methods: {
    changeStep (num) {
      this.num = num
    }
  }
}
